import { httpClient } from "@sia/style-guide";
import createSurveyAdapter from "./SurveyAdapter";

const surveyAdapter = createSurveyAdapter(httpClient);
export default surveyAdapter;
